import { GET_CARD,  GET_TABLE,
   GET_BUILDING, CHECK_OUT, GET_VISITOR_HISTORY,
 } from "./constant";

export function getTableRequest(data){
  return {
    type:GET_TABLE.PENDING,
    data
  }
}

export function getTableSuccess(data){
  return {
    type:GET_TABLE.SUCCESS,
    data
  }
}

export function getTableError(err){
  return {
    type:GET_TABLE.ERROR,
    err
  }
}


export function getCardRequest(){
  return {
    type:GET_CARD.PENDING,
  }
}
export function getCardSuccess(data){
   return {
     type:GET_CARD.SUCCESS,
     data
   }
}
export function getCardError(err){
  return {
    type:GET_CARD.ERROR,
    err
  }
}
export function getBuildingData(data){
  return {
    type:GET_BUILDING.PENDING,
    data
  }
}
export function getBuildingSuccess(data){
  return {
    type:GET_BUILDING.SUCCESS,
    data
  }
}
export function getBuildingError(err){
  return {
    type:GET_BUILDING.ERROR,
    err
  }
}

export function checkOutRequest(data){
  return {
    type:CHECK_OUT.PENDING,
    data
  }
}

export function checkOutSuccess(data){
  return {
    type:CHECK_OUT.SUCCESS,
    data
  }
}

export function checkOutError(err){
  return {
    type:CHECK_OUT.ERROR,
    err
  }
}

/* ------------------------------------------------------- visitor record */

/** Opens the visitor record modal and loads that number's visit history. */
export function openVisitorRecord(row){
  return {
    type:'VISITOR_RECORD_OPEN',
    row
  }
}

export function closeVisitorRecord(){
  return {
    type:'VISITOR_RECORD_CLOSE',
  }
}

export function getVisitorHistoryRequest(data){
  return {
    type:GET_VISITOR_HISTORY.PENDING,
    data
  }
}

export function getVisitorHistorySuccess(data){
  return {
    type:GET_VISITOR_HISTORY.SUCCESS,
    data
  }
}

export function getVisitorHistoryError(err){
  return {
    type:GET_VISITOR_HISTORY.ERROR,
    err
  }
}
